import React from 'react';
// Images
import BackgroundImage from '../../assets/images/backgrounds/the-tavistock-hotel-and-inn-hero.webp';
import DividerImage from '../../assets/images/icons/divider-ornament-transparent.png';
// Components
import Navbar from '../nav/Navbar';

const HomePageHeader = () => {
  const menuItems = [
    { name: 'Rooms', id: 'rooms' },
    { name: 'Food', id: 'menu' },
    { name: 'Ales', id: 'menu', hidden: true },
    { name: 'Music', id: 'music', hidden: true },
    { name: 'Poker', id: 'poker' },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className='relative grid grid-rows-a1a bg-cover bg-no-repeat bg-center min-h-screen'
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <Navbar />

      {/* Dark Overlay */}
      <div className='absolute inset-0 bg-black bg-opacity-65'></div>

      <section className='relative grid h-full w-full'>
        {/* Google score */}
        <div className='absolute bottom-6 lg:grid left-1/2 lg:left-0 transform -translate-x-1/2 lg:-translate-x-0 lg:right-6 lg:justify-end'>
          <div className='bg-black bg-opacity-70 text-white text-lg md:text-2xl px-4 py-2 rounded-tl-md shadow-lg flex items-center gap-2 font-medium w-fit'>
            <span>⭐ 4.5</span>
            <span className='text-gray-300'>on Google</span>
          </div>
        </div>

        {/* Header text */}
        <div className='grid items-center justify-center px-2 z-20 lg:-mt-6 xl:-mt-16'>
          <article className='grid h-fit px-2 lg:h-fit'>
            <div className='text-center'>
              <h1 className='text-5xl md:text-6xl text__stroke lg:text-8xl font-GaramondBold font-bold mb-4 text-shadow-lg text-colour2'>
                <span className='text-4xl lg:text-5xl'>Welcome to</span> <br />{' '}
                The Tavistock Inn
              </h1>
            </div>

            <div className='mx-auto'>
              <img src={DividerImage} alt='' />
            </div>
            {/* Subheading */}
            <div>
              <div className='text-center'>
                <h2 className='text-xl font-medium md:text-2xl font-GaramondBold mb-6 text-shadow-md text-white'>
                  A Traditional British Pub and Hotel <br /> Located in
                  Tavistock, Devon
                </h2>
              </div>

              <div className='hidden lg:grid justify-center grid-cols-2 text-center text-lg w-fit mx-auto gap-4'>
                <div className='grid w-full'>
                  <a
                    href='#rooms'
                    className='text-colour2 hover:brightness-125 transition duration-300 underline underline-offset-4'
                  >
                    View Rooms
                  </a>
                </div>

                <div className='grid w-full'>
                  <a
                    href='tel:+441822481240'
                    className='text-colour2 hover:brightness-125 transition duration-300 underline underline-offset-4'
                  >
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className='grid z-20 font-GaramondBold h-fit py-4 px-2 bg-colour1  border-t-2 border-solid border-colour2'>
        <ul className='grid grid-cols-3 lg:grid-cols-5 text-colour2 text-xl font-semibold'>
          {menuItems.map(({ name, id, hidden }) => (
            <li
              key={name}
              className={`text-center ${hidden ? 'hidden lg:grid' : ''}`}
            >
              <button
                onClick={() => scrollToSection(id)}
                className='hover:brightness-125 transition duration-300 underline underline-offset-4'
              >
                {name}
              </button>
            </li>
          ))}
        </ul>
      </section>
    </header>
  );
};

export default HomePageHeader;
